import {Text} from '@ui-kitten/components';
import React from 'react';
import {ScrollView, StyleSheet} from 'react-native';
import {px} from '../../utils';
import {Page} from '../components';
import {data} from './data';

const TermsOfServices = () => {
  return (
    <Page header={{title: 'Terms of services', showBackAction: true}}>
      <ScrollView contentContainerStyle={styles.scrollView}>
        {data.map(({text, type}, index) => (
          <Text key={index} style={styles[type]}>
            {text}
          </Text>
        ))}
      </ScrollView>
    </Page>
  );
};

const styles = StyleSheet.create({
  scrollView: {
    padding: px(17),
  },
  header: {
    marginTop: px(17),
    marginBottom: px(4),
    fontWeight: 'bold',
  },
  normal: {},
  bullet: {
    marginLeft: px(17),
  },
});

export default TermsOfServices;
